import type { FC } from 'react'
import MultiSelect from './MultiSelect'
import type { Parameter } from '@/features/shared/domain/models/parameters'

export interface Filter {
  id: string
  labelKey: string
  options: Parameter
  canSelectAll: boolean
  initialSelected?: string[]
}

interface FiltersProps {
  filters: Filter[]
  onFilterSelected: (key: string, filters: string[]) => void
}

const Filters: FC<FiltersProps> = ({ filters, onFilterSelected }) => (
  <div className="flex flex-row items-center justify-between gap-[16px]">
    {filters.map(({ id, labelKey, options, canSelectAll, initialSelected }) => (
      <MultiSelect
        key={id}
        options={options}
        filterNameKey={labelKey}
        hasSelectAll={canSelectAll}
        initialSelected={initialSelected}
        onChange={(selected) => {
          onFilterSelected(id, selected)
        }}
      />
    ))}
  </div>
)

export default Filters
